import type { StaticScreenProps } from "@react-navigation/native";
import { useCallback } from "react";
import { LoginOtpForm } from "../components";
import { actions } from "../services";

type Props = StaticScreenProps<{
  email: string | null;
  emailVerified: boolean;
  phone: string;
}>;

export function LoginOtpScreen({ route }: Props) {
  // Params
  const { email, emailVerified, phone } = route.params;

  // Handlers
  const handleSuccess = useCallback((token: string) => {
    actions.startSession(token);
  }, []);

  // Render
  return (
    <LoginOtpForm
      email={email}
      emailVerified={emailVerified}
      onSuccess={handleSuccess}
      phone={phone}
    />
  );
}
